import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './slices/authSlice';
import websocketReducer from './slices/websocketSlice';
import loadReducer from './slices/loadSlice';
import loadFeedReducer from './slices/loadFeedSlice';
import { websocketMiddleware } from './middleware/websocketMiddleware';
import notificationReducer from './slices/notificationSlice';
import loadCarrierReducer from './slices/loadCarrierSlice';
import billingReducer from './slices/billingSlice';
import vehicleReducer from './slices/vehicleSlice';
import telematicsReducer from './slices/telematicsSlice';
import trackingHistoryReducer from './slices/trackingHistorySlice';
import messagingReducer from './slices/messagingSlice';
import notificationSettingsReducer from './slices/notificationSettingsSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  websocket: websocketReducer,
  load: loadReducer,
  loadFeed: loadFeedReducer,
  notifications: notificationReducer,
  loadCarrier: loadCarrierReducer,
  billing: billingReducer,
  vehicles: vehicleReducer,
  telematics: telematicsReducer,
  trackingHistory: trackingHistoryReducer,
  messaging: messagingReducer,
  notificationSettings: notificationSettingsReducer,
});

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['auth', 'load'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, 'websocket/connect/fulfilled'],
        ignoredPaths: ['websocket.socket'],
      },
    }).concat(websocketMiddleware),
});

export const persistor = persistStore(store);
